<template>
  <l-section class="text" v-editable="blok" :class="`--align-${blok.align}`">
    <l-container>
      <div class="text__richtext">
        <sb-richtext :text="blok.text" />
      </div>
    </l-container>
  </l-section>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss" scoped>
.text {
  margin-bottom: pxToRem(10);
  &:first-child {
    margin-top: 5rem;
    &:last-child {
      margin-bottom: 5rem;
    }
  }
  &__richtext {
    max-width: 50rem;
    .--align-center & {
      margin: 0 auto;
    }
    .--align-right & {
      margin-left: auto;
    }
    .--align-left & {
      margin-right: auto;
    }

    :deep(h1),
    :deep(h2),
    :deep(h3),
    :deep(h4),
    :deep(h5),
    :deep(h6) {
      &:not(:first-child) {
        margin-top: 3rem;
      }
      &:not(:last-child) {
        margin-bottom: 1.5rem;
      }
    }

    :deep(ol),
    :deep(ul) {
      list-style: initial;
      margin-top: 0.4rem;
      margin-bottom: 3.2rem;
    }
    :deep(li) {
      position: relative;
      display: block;
      margin-bottom: 0.4rem;
      padding-left: 2.4rem;
      &:before {
        content: "•";
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;
        width: 2.4rem;
      }
    }

    :deep(p:has(+ ul)),
    :deep(p:has(+ ol)) {
      margin-bottom: 0.8rem;
    }
  }
}
</style>
